<template>
  <b-form-group
    :label="title"
    :label-for="item"
  >
    <validation-provider
      #default="{ errors }"
      :name="title"
      rules="required"
    >
      <b-form-input
        :id="item"
        v-model="dataItem[item]"
        placeholder="Giriniz"
        :type="type"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'PurchaseOfferConfigValue',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    item: {
      type: String,
      required: true,
    },
    type: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOfferConfig/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
